type ReleaseLockFunction = () => void

/**
 * Object that provide Get/Set internal value in thread-safe manner
 */
export default class Interlock<T> {
    private lockValue: T
    private queue: { resolve: (value: ReleaseLockFunction) => void }[] = []
    private _isLocked = false

    constructor(initialValue: T) {
        this.lockValue = initialValue
    }

    /**
     * run next waiting task in queue
     */
    private aqquireLock() {
        return new Promise<ReleaseLockFunction>((resolve) => {
            this.queue.push({ resolve })
            this.dispatch()
        })
    }

    private dispatch() {
        if (this._isLocked) {
            return
        }
        const task = this.queue.shift()
        if (task) {
            this._isLocked = true
            const { resolve: nextResolve } = task
            nextResolve(this.buildReleaseFunction())
        }
    }

    async getValue(): Promise<T> {
        const release = await this.aqquireLock()

        // release lock using Browser Timeout API to post callback to JS Main Thread
        setTimeout(async () => {
            await release()
        }, 1)

        return this.lockValue
    }

    async setValue(newValue: T): Promise<void> {
        const release = await this.aqquireLock()
        this.lockValue = newValue

        setTimeout(async () => {
            await release()
        }, 1)
    }

    private buildReleaseFunction(): ReleaseLockFunction {
        return () => {
            this._isLocked = false

            // try dequeue next task
            this.dispatch()
        }
    }
}
